import React from 'react';
import { Results } from '../../../../SectionBlocks/Testshowcase/Results/Results';
import { TestResultBlock } from '../../../../../../../types/testResultBlock';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../BlockContent.utils';

interface TestResultSerializerProps {
  value: TestResultBlock;
}

const Block: React.FC<TestResultSerializerProps> = ({ value }) => <Results block={value} />;

export const TestResultSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: TestResultSerializerProps) => (
      <ArticleBlockContentGridCol>
        <Block value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: TestResultSerializerProps) => <Block value={value} />;
};
